import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC } from 'react';
import { useTranslation } from "react-i18next";
import { LayoutConst, useModal } from "../../../core";
import { RectangularButtonFilled } from "shared/components/buttons";

const Wrapper = styled(FlexBox)`
    width: 100%;
    background: #FEFEFE;
    position: relative;
    flex-flow: column;
    align-items: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
  }
`;

const Title = styled.div`
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
    color: #151514;
    margin-bottom: 16px;
  

`;

const Message = styled.div`
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;
    color: #343434;
    margin-bottom: 32px;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-size: 14px;
      line-height: 20px;
    }
`;

const ButtonsWrapper = styled(FlexBox)`
    gap: 16px;
    justify-content: center;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
      flex-direction: column;
      gap: 12px;
    }
`;

const PrimaryButton = styled(RectangularButtonFilled)`
    min-width: 258px;
    height: 48px;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
      min-width: 100%;
    }
`;

interface PaymentErrorModalProps {
    title?: string;
    message?: string;
    returnButtonText?: string;
}

export const PaymentErrorModal: FC<PaymentErrorModalProps> = ({ 
    title = 'Ошибка',
    message = 'Оплата отклонена провайдером',
    returnButtonText = 'Вернуться к модулю'
}) => {
    const { t } = useTranslation();
    const modal = useModal();

    const handleReturnToCourse = () => {
        modal.hide();
    };

    return (
        <Wrapper>
            <Title>{title}</Title>
            <Message>{message}</Message>
            <ButtonsWrapper>
                <PrimaryButton 
                    onClick={handleReturnToCourse}
                >
                    {returnButtonText}
                </PrimaryButton>
            </ButtonsWrapper>
        </Wrapper>
    );
};
import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC } from 'react';
import { useTranslation } from "react-i18next";
import { LayoutConst, useModal } from "../../../core";
import { RectangularButtonFilled } from "shared/components/buttons";

const Wrapper = styled(FlexBox)`
    width: 100%;
    background: #FEFEFE;
    position: relative;
    flex-flow: column;
    align-items: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
  }
`;

const Title = styled.div`
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
    color: #151514;
    margin-bottom: 16px;
  

`;

const Message = styled.div`
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;
    color: #343434;
    margin-bottom: 32px;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-size: 14px;
      line-height: 20px;
    }
`;

const ButtonsWrapper = styled(FlexBox)`
    gap: 16px;
    justify-content: center;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
      flex-direction: column;
      gap: 12px;
    }
`;

const PrimaryButton = styled(RectangularButtonFilled)`
    min-width: 258px;
    height: 48px;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
      min-width: 100%;
    }
`;

interface PaymentErrorModalProps {
    title?: string;
    message?: string;
    returnButtonText?: string;
}

export const PaymentErrorModal: FC<PaymentErrorModalProps> = ({ 
    title = 'Ошибка',
    message = 'Оплата отклонена провайдером',
    returnButtonText = 'Вернуться к модулю'
}) => {
    const { t } = useTranslation();
    const modal = useModal();

    const handleReturnToCourse = () => {
        modal.hide();
    };

    return (
        <Wrapper>
            <Title>{title}</Title>
            <Message>{message}</Message>
            <ButtonsWrapper>
                <PrimaryButton 
                    onClick={handleReturnToCourse}
                >
                    {returnButtonText}
                </PrimaryButton>
            </ButtonsWrapper>
        </Wrapper>
    );
};
